import { DealThreadMessageCreatedData } from "@/src/contexts/websockets";
import { AppState } from "..";

function dealThreadMessages(
  state: AppState,
  id: string,
): DealThreadMessageCreatedData[] {
  if (!id) {
    return [];
  }

  return state.assistant.dealThreads[id];
}

function activeDealThreadId(state: AppState): string | undefined {
  return state.assistant.activeDealThreadId;
}

function assistantDisplayMode(state: AppState): "panel" | "slideover" {
  return state.assistant.assistantDisplayMode;
}

export const assistantSelectors = {
  dealThreadMessages,
  activeDealThreadId,
  assistantDisplayMode,
};
